import {connect} from 'react-redux';
import {TipBox as Component} from './TipBox';
import {
  createTipBox,
  tipBoxOpen
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("tipBoxes") &&
     state.notebook.protocolSection.scene.apparatus.tipBoxes.some(
       tipBox => tipBox.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.tipBoxes[ownProps.id-1].type,
      open: state.notebook.protocolSection.scene.apparatus.tipBoxes[ownProps.id-1].open
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createTipBox: (data) => {
      dispatch(createTipBox(data))
    },
    tipBoxOpen: (data) => {
      dispatch(tipBoxOpen(data))
    }
  };
}

export const TipBox = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
